/**
 * SoleadLab 2.0 - Thermal Analysis Types
 *
 * Shared TypeScript interfaces for thermal image annotation,
 * ROI measurement, and data persistence.
 *
 * REFERENCE: editor (23).html ThermalAnnotatorModule (lines 7290-7616)
 */

import type { RadiometricParams, RoiStats } from '../../../utils/djiThermalParser';

export type { RadiometricParams, RoiStats } from '../../../utils/djiThermalParser';

export const DEFAULT_RADIOMETRIC_PARAMS: RadiometricParams = {
  emissivity: 0.95,
  distance_m: 10,
  humidity_pct: 40,
  air_temp_c: 30,
  reflected_temp_c: 25,
};

/** A rectangle ROI in image-pixel coordinates */
export interface ThermalRoi {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  stats: RoiStats | null;
}

/** A point measurement in image-pixel coordinates */
export interface ThermalPoint {
  x: number;
  y: number;
  value_c: number | null;
}

/** Drawing mode for the thermal annotator canvas */
export type AnnotatorMode = 'rect' | 'point';

/** Drag state for pointer interactions */
export type DragState =
  | { type: 'new-rect'; idx: number }
  | { type: 'resize'; idx: number; handle: 'nw' | 'ne' | 'sw' | 'se' }
  | { type: 'move'; idx: number; ox: number; oy: number; rx0: number; ry0: number; rx1: number; ry1: number }
  | { type: 'new-point'; idx: number }
  | { type: 'move-point'; idx: number }
  | null;

/** Complete thermal analysis data persisted on an indication */
export interface ThermalAnalysisData {
  rois: ThermalRoi[];
  points: ThermalPoint[];
  params: RadiometricParams;
  snapshot?: string; // data:image/png composite
}
